/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Settings_Collaborators_Nrolesupdated2Inputs */

const en_settings_collaborators_nrolesupdated2 = /** @type {(inputs: Settings_Collaborators_Nrolesupdated2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} updated`)
};

/**
* | output |
* | --- |
* | "{count} updated" |
*
* @param {Settings_Collaborators_Nrolesupdated2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_nrolesupdated2 = /** @type {((inputs: Settings_Collaborators_Nrolesupdated2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Nrolesupdated2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_nrolesupdated2(inputs)
});
export { settings_collaborators_nrolesupdated2 as "settings_collaborators_nRolesUpdated" }